module.exports = __webpack_public_path__ + "static/media/raconteur-music-1024.5de5bc9d.png";